import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import SummaryApi from "../common/index";
import { message } from "antd";
import { UserContext } from "./UserContext";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const { user } = useContext(UserContext);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);



  const fetchCart = async () => {
    if (!user || user.role !== "Customer") return; // Only fetch for Customer

    const token = localStorage.getItem("token");
    try {
      const res = await axios({
        method: SummaryApi.getCart(user.id).method,
        url: SummaryApi.getCart(user.id).url,
        headers: { Authorization: `Bearer ${token}` },
      });
      setCart(res.data.cartItems || []);
      console.log("Cart fetched:", res.data.cartItems);
    } catch (err) {
      console.error("Error fetching cart:", err);
      if (err.response?.status === 401) {
        message.error("Unauthorized! Please login again.");
      }
    }
  };

  const addToCart = async (product) => {
    if (!user || user.role !== "Customer") return message.warning("Please login as Customer first!");

    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        SummaryApi.addToCart.url,
        { userId: user.id, productId: product.id, quantity: 1 },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        fetchCart();
        message.success(res.data.message || "Product added to cart!");
      } else {
        message.warning(res.data.message || "Product already in cart!");
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
      message.error(err.response?.data?.message || "Something went wrong while adding to cart!");
    }
  };

  const updateCartItem = async (id, quantity) => {
  if (!user || user.role !== "Customer") return;

  try {
    const cartItem = cart.find(item => item.id === id);
    if (!cartItem) return;

    // Prevent increasing beyond stock
    if (quantity > cartItem.product.stock) {
      return message.warning(`Cannot exceed available stock (${cartItem.product.stock})`);
    }

    const token = localStorage.getItem("token");
    await axios.put(
      SummaryApi.updateCartItem(id).url,
      { quantity },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    fetchCart();
  } catch (err) {
    console.error("Error updating cart item:", err);
  }
};


  const removeFromCart = async (id) => {
    if (!user || user.role !== "Customer") return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(SummaryApi.deleteCartItem(id).url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchCart();
    } catch (err) {
      console.error("Error removing cart item:", err);
    }
  };


  useEffect(() => {
    if (user && user.role === "Customer") fetchCart();
    else setCart([]); // clear cart on logout or non-customer login
  }, [user]);

  return (
    <CartContext.Provider
      value={{
        cart,
        loading,
        fetchCart,
        addToCart,
        updateCartItem,
        removeFromCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
